// src/theme/theme.ts
import { extendTheme } from '@chakra-ui/react';

export const theme = extendTheme({
  colors: {
    brand: {
      primary: "#7e28af",    // Fundo principal - roxo
      secondary: "#ffffff",   // Branco
      dark: "#653976",        // Roxo escuro
      gray100: "#F7FAFC",
      gray200: "#E2E8F0",
      gray600: "#4A5568",
      gray700: "#2D3748",
      gray800: "#1A202C",
      cyan: "#4befef",       // Ciano - destaque/botões CTA
      pink: "#653976"        // Roxo escuro - accent secundário
    },
  },
  fonts: {
    heading: "Poppins, sans-serif",
    body: "Poppins, sans-serif",
  },
});
